import { json } from './platformAuth';

export type Plan = {
  overview: string;
  goalUsers: string;
  capabilitiesWorkflows: string[];
  implementationSteps: { title: string; acceptanceCriteria: string[]; completed?: boolean }[];
  discoveryFindings: { finding: string; source: string; mapping?: string }[];
  discoveryScopes?: {
    systemId: string;
    entity: string;
    purpose: string;
    allowedFields?: string[];
    filter?: string;
  }[];
  assumptions: string[];
  outOfScope: string[];
  blockingQuestions: string[];
};
export type PlanState = {
  phase: string | null;
  discoveryApproved: boolean;
  discoveryScopesApproved: boolean;
  plan: Plan | null;
  revision: number | null;
  checklist: { key: string; complete: boolean }[];
  blockers: string[];
};
const path = (id: string) => `/app/fabrik/apps/${encodeURIComponent(id)}/plan`;
export const getPlan = (tenantId: string, id: string, signal?: AbortSignal) =>
  json<PlanState>(path(id), tenantId, { signal, cache: 'no-store' });

export const getPlanAtRevision = async (
  tenantId: string,
  id: string,
  minimumRevision: number,
  signal?: AbortSignal
) => {
  let latest = await getPlan(tenantId, id, signal);
  for (let attempt = 0; (latest.revision ?? 0) < minimumRevision && attempt < 2; attempt++) {
    await new Promise((resolve) => setTimeout(resolve, 100 * (attempt + 1)));
    latest = await getPlan(tenantId, id, signal);
  }
  return latest;
};
export const approvePlan = (
  tenantId: string,
  id: string,
  revision: number,
  next: 'discovery' | 'implementation'
) =>
  json<PlanState>(`${path(id)}/approve`, tenantId, {
    method: 'POST',
    body: JSON.stringify({ expectedRevision: revision, next }),
  });
export const approveDiscovery = (tenantId: string, id: string, revision: number) =>
  json<PlanState>(`${path(id)}/discovery/approve`, tenantId, {
    method: 'POST',
    body: JSON.stringify({ expectedRevision: revision }),
  });
export const approveDiscoveryScopes = (tenantId: string, id: string, revision: number) =>
  json<PlanState>(`${path(id)}/discovery/scopes/approve`, tenantId, {
    method: 'POST',
    body: JSON.stringify({ expectedRevision: revision }),
  });
